export default {"src":"/_next/static/image/public/images/flags/flag_967.78b6a4da61d0a380afc9e5aaa5049ed7.svg","height":16,"width":24};